// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"78151ccc","453":"b5d3b766","934":"f116c891"}[chunkId] + ".chunk.js";
};